/*
 * Copyright (c) Nexign, JSC, 2019.
 */


/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.1.0
 */

import { createAction } from '../../app/createAction';
import { PUSH_GTM_ANALYTIC } from './GTMconstants';
import { IGTMPushAnalyticPayload, TGTMPushAnalyticAction } from './types/GTMActionTypes';

export const pushGTMAnalytic = (payload: IGTMPushAnalyticPayload): TGTMPushAnalyticAction => 
    createAction(PUSH_GTM_ANALYTIC, payload);
